import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { filesAPI } from 'src/api/modules/files';
import notice from 'src/common/components/Notice';
import PageLayout from 'src/common/components/PageLayout';
import UpFileResumable from '../Files/upFileResumable';
import { saveAs } from 'file-saver';
import { bitacoraApi } from 'src/api/modules/bitacora';
import FilePreviewer from 'react-file-previewer';
const useQuery = () => {
	const { search } = useLocation();

	return React.useMemo(() => new URLSearchParams(search), [search]);
};
const Visualizer = () => {
	const [fileData, setFileData] = useState(null);
	const [mimeType, setmimeType] = useState();
	const { user } = useSelector((state) => state.auth);
	let query = useQuery();
	const setMimeTypeB = (blob) => {
		const nameFileArray = query.get('nameFile').split('.');
		const extension = nameFileArray[nameFileArray.length - 1];
		let mimeType = 'data:application/octet-stream';
		console.log(extension);
		switch (extension) {
			case 'pdf':
				setmimeType('application/pdf');
				mimeType = 'application/pdf';

				break;
			case 'png':
				setmimeType('image/png');
				mimeType = 'image/png';
				break;
			case 'jpg' || 'jpeg ':
				setmimeType('image/jpeg');
				mimeType = 'image/jpeg';
				break;

			default:
				saveAs(blob, query.get('nameFile').replaceAll('acute;', ' '));
				break;
				return mimeType;
		}
	};
	const previewFile = (blob) => {
		const file = blob;
		const reader = new FileReader();
		reader.addEventListener('loadend', () => {
			const fdatArra = reader.result.split('base64');
			console.log(fdatArra);
			setFileData(fdatArra[fdatArra.length - 1].substring(1));
		});
		reader.readAsDataURL(file);
	};
	const downloadMigrated = () => {
		filesAPI.DownloadFilesMigrated(query.get('ruta')).then((response) => {
			if (response.size > 0) {
				let blob = new Blob([response], { type: setMimeTypeB(response) });
				previewFile(blob);
				registerBinnacle();
			} else {
				notice('No se pudo descargar el archivo ', 'info');
			}
		});
	};
	const registerBinnacle = () => {
		const data = {
			accion: `El usuario ${user.nombre} ${user.apellidoPaterno} ${
				user.apellidoMaterno
			} ha descargado el archivo ${query
				.get('nameFile')
				.replaceAll('acute;', ' ')} desde el link de carpeta electrónica`,
		};
		bitacoraApi.post(data);
	};
	const download = () => {
		const fileResumable = new UpFileResumable();
		//const datosDesifrados = fileResumable._desifrarDatos();
		const params = {
			ruta: query.get('ruta'),
			tipoUsuarioConsulta: 'admin',
			archivo: query.get('nameFile').replaceAll('acute;', ' '),
			usuarioConsulta:
				user.nombre + ' ' + user.apellidoPaterno + ' ' + user.apellidoMaterno,
		};
		filesAPI
			.downloadMinos(params)
			.then((response) => {
				if (response.size > 0) {
					let blob = new Blob([response], { type: setMimeTypeB(response) });
					previewFile(blob);
					registerBinnacle();
				} else {
					notice('No se pudo descargar el archivo de Minos', 'info');
				}
			})
			.catch((err) => notice('No se pudo descargar el archivo de Minos', 'info'))
			.finally(() => {});
	};
	useEffect(() => {
		let ruta = query.get('ruta');
		if (ruta.includes('/')) download();
		else downloadMigrated();
	}, []);

	return (
		<PageLayout>
			<h3>Visualizador de archivos</h3>
			<div>
				<FilePreviewer
					file={{
						data: '' + fileData,
						mimeType: '' + mimeType,
						name: query.get('nameFile').replaceAll('acute;', ' '), // for download
					}}
				/>
			</div>
		</PageLayout>
	);
};

export default Visualizer;
